import { Home, Gavel, Group, Store, Work, Ballot, AccountBalance, ShoppingCart, LocalAtm, Build } from '@material-ui/icons'

const procurementCollapse = localStorage.getItem('procurementCollapse') === 'true'
const legalCollapse = localStorage.getItem('legalCollapse') === 'true'
const bankGuaranteeCollapse = localStorage.getItem('bankGuaranteeCollapse') === 'true'
const bgCompanyBuy = localStorage.getItem('bgCompanyBuy') === 'true'
const bgCompanySale = localStorage.getItem('bgCompanySale') === 'true'

export const menus = [
  {
    path: '/',
    name: 'Home',
    icon: Home
  },
  {
    path: '/legalsystem',
    name: 'Legal System',
    icon: Gavel,
    collapse: legalCollapse,
    subMenus: [
      {
        path: '/legalsystem/contract',
        name: 'Contract',
        icon: null
      },
    ]
  },
  {
    path: '/procurement',
    name: 'Procurement System',
    icon: Group,
    collapse: procurementCollapse,
    subMenus: [
      // {
      //   path: '/procurement/vendorApplication',
      //   name: 'Vendor Application',
      //   icon: null
      // },
      // {
      //   path: '/procurement/tracking',
      //   name: 'Tracking',
      //   icon: null
      // },
      {
        path: '/rfp',
        name: 'Request for Proposal',
        icon: null,
        link: true
      },
      {
        path: '/procurement/purchaseRequisition',
        name: 'Purchase Requisition',
        icon: null
      },
      {
        path: '/procurement/requestForQuotation',
        name: 'Request for Quotation',
        icon: null
      },
      {
        path: '/procurement/purchaseOrder',
        name: 'Purchase Order',
        icon: null
      },
      {
        path: '/procurement/downpayment',
        name: 'Down Payment',
        icon: null
      },
      {
        path: '/procurement/goodsServiceReceipt',
        name: 'Goods/Service Receipt',
        icon: null
      },
      {
        path: '/procurement/billform',
        name: 'Billing',
        icon: null
      },
      {
        path: '/procurement/purchaseOrderUpdate',
        name: 'Update/Cancel PO',
        icon: null
      },
      {
        path: '/procurement/CodeOfConduct',
        name: 'Supplier Code of Conduct',
        icon: null
      },
    ]
  },
  {
    path: '/vendorMaintenance',
    name: 'Vendor Maintenance',
    icon: Work
  },
  {
    path: '/product',
    name: 'Product',
    icon: Store
  },
  {
    path: '/shortList',
    name: 'Short List',
    icon: Ballot
  },
  {
    path: '/bankGuarantee',
    name: 'Bank Guarantee',
    collapse: bankGuaranteeCollapse,
    icon: AccountBalance,
    subMenus: [
      {
        path: '/bankGuarantee/vendor',
        name: 'Vendor BG',
        icon: ShoppingCart,
        collapse: bgCompanyBuy,
        subMenus: [
          {
            path: '/bankGuarantee/vendor/report',
            name: 'BG Report',
          },
          // {
          //   path: '/bankGuarantee/vendor/po',
          //   name: 'PO Report',
          // },
          {
            path: '/bankGuarantee/vendor/request',
            name: 'Request Change/Return',
          }
        ]
      },
      {
        path: '/bankGuarantee/company',
        name: 'Company BG',
        icon: LocalAtm,
        collapse: bgCompanySale,
        subMenus: [
          {
            path: '/bankGuarantee/company/report',
            name: 'BG Report',
          },
          {
            path: '/bankGuarantee/company/request',
            name: 'Request New/Extend',
          },
          {
            path: '/bankGuarantee/company/bank',
            name: 'Set up Limit of Bank',
          }
        ]
      },
    ]
  },
  {
    path: '/support',
    name: 'Support',
    icon: Build,
  },
  // {
  //   path: '/admin',
  //   name: 'Admin',
  //   icon: Group,
  //   admin: true,
  //   collapse: true,
  //   subMenus: [
  //     {
  //       path: '/admin/userRole',
  //       name: 'Role User Management',
  //       icon: null
  //     },
  //     {
  //       path: '/admin/role',
  //       name: 'Role Permission Management',
  //       icon: null
  //     },
  //     {
  //       path: '/admin/permission',
  //       name: 'Permission Management',
  //       icon: null
  //     },
  //     {
  //       path: '/admin/adjustDepartmentUser',
  //       name: 'Adjust Department User Management',
  //       icon: null
  //     },
  //     {
  //       path: '/admin/projectRoles',
  //       name: 'Project Role Management',
  //       icon: null
  //     },
  //     {
  //       path: '/admin/prManagements',
  //       name: 'Purchase Requisition Managements',
  //       icon: null
  //     }
  //   ]
  // },
]
